module.exports = __webpack_public_path__ + "static/media/levelOn05.a8eeb30e.svg";